import React, { useContext, useMemo } from "react";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  split,
  ApolloProvider,
  ApolloLink,
} from "@apollo/client";
import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { AuthContext } from "./auth.context";
import { AUTH_TYPE } from "aws-appsync";
import { Auth } from "aws-amplify";

export const getApolloClient = () => {
  const url =
    process.env.REACT_APP_ENV === "production"
      ? "https://sx3blo4q2bhtzmypt3g77qdhl4.appsync-api.eu-west-2.amazonaws.com/graphql"
      : "https://i77bsirmyvcszaqtnywotvrjr4.appsync-api.eu-west-2.amazonaws.com/graphql";

  const httpLink = new HttpLink({ uri: url });

  const subscriptionLink = createSubscriptionHandshakeLink(
    {
      url,
      region: "eu-west-2",
      auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () =>
          (await Auth.currentSession()).getIdToken().getJwtToken(),
      },
    },
    httpLink
  );

  const authLink = createAuthLink({
    url,
    region: "eu-west-2",
    auth: {
      type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
      jwtToken: async () =>
        (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
  });

  const link = ApolloLink.from([authLink, subscriptionLink]);

  const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });

  return client;
};

type Props = {
  children?: React.ReactNode;
};

const AuthorisedApolloProvider = ({ children }: Props) => {
  const apolloClient = useMemo(() => {
    return getApolloClient();
  }, []);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default AuthorisedApolloProvider;
